// Import React Libraries
import React from "react";

// Import Ionic Components
import { IonCardSubtitle, IonCol, IonItem, IonLabel, IonRow, IonThumbnail } from "@ionic/react";

// Import styles
import classNames from "classnames/bind";
import styles from "./MyOrderProduct.module.scss";
import { Image } from "../Image/Image";
import { LineItem } from "@core/types";
import { formatCurrency } from "../../utils/currencyUtils";
import { getPreviewImage } from "../../utils/getPreviewImage";
import { useTranslation } from "react-i18next";
import { useConfig } from "../../providers/config";

const cx = classNames.bind(styles);

const MyOrderProduct: React.FC<{ item: LineItem; currencySymbol: string; onClick?: Function }> = ({
  item,
  currencySymbol,
  onClick,
}) => {
  const { t } = useTranslation();
  const { showParentName } = useConfig();
  const productImage = getPreviewImage(item.image);

  return (
    //====================================  list view for shop page ====================================
    <div>
      <IonRow>
        <IonCol>
          {showParentName && item.parentName ? (
            <div className="flex flex-col gap-1">
              <div className={cx("product__title")}>{item.parentName}</div>
              <div className={cx("product__title")}>{item.name}</div>
            </div>
          ) : (
            <div className={cx("product__title")}>{item.name}</div>
          )}
        </IonCol>
      </IonRow>
      <IonItem className={cx("product__item")} lines="full">
        <IonThumbnail slot="start">
          <Image className={cx("product__img")} onClick={() => onClick && onClick()} image={productImage} />
        </IonThumbnail>
        <IonLabel>
          {item.price && (
            <IonRow>
              <IonCol className="ion-text-left" size="6">
                {t("Price")}&nbsp;:&nbsp;
              </IonCol>
              <IonCol className="ion-text-right" size="6">{`${Number(item.price).toFixed()} ${currencySymbol}`}</IonCol>
            </IonRow>
          )}
          <IonRow>
            <IonCol className="ion-text-left" size="6">
              {t("Quantity")}&nbsp;:&nbsp;
            </IonCol>
            <IonCol className="ion-text-right" size="6">
              {item.quantity}
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol className="ion-text-left" size="6">
              <strong>{t("Total")}</strong>&nbsp;:&nbsp;
            </IonCol>
            <IonCol className="ion-text-right" size="6">
              <strong>{`${formatCurrency(Number(item.total!), currencySymbol)}`} </strong>
            </IonCol>
          </IonRow>
        </IonLabel>
      </IonItem>
    </div>
  );
};
export { MyOrderProduct };
